import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";
import { CookieService } from '../Services/cookie';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { ErrorMessageKeyService } from "../Services/error-message-key.service";
import { AuthService } from '../Services/auth.service';
import { CommonService } from './../Services/common.service';


@Component({
  selector: 'app-change-card-pin-sinnad',
  templateUrl: './change-card-pin-sinnad.component.html',
  standalone:false,
  styleUrls: ['./change-card-pin-sinnad.component.scss']
})
export class ChangeCardPinSinnadComponent implements OnInit {


  newOtp: string = "";
  otp1: string;
  // otpform: FormGroup;

  constructor(private router:Router, private CommonService: CommonService,public errorKey: ErrorMessageKeyService,private fb: FormBuilder, public translate: TranslateService, private location: Location,private cookieService: CookieService, public auth: AuthService,) {

    // this.otpform = new FormGroup({
    //   changeotp: new FormControl("", Validators.compose([
    //     Validators.required,
    //     Validators.pattern("^[a-zA-Z0-9]*$"),
    //     Validators.minLength(4),
    //   ])),
    //   //  Validators.maxLength(35)
    //   // bankbranchcodeoptional: new FormControl("", Validators.compose([Validators.pattern("[0-9]*")])),
    //   // bankbranchname: new FormControl("", Validators.compose([Validators.required])),
    //   // , Validators.pattern("[a-zA-Z 0-9 _\"'\\?\\-\\/.,@!]*"),
    // });
    }

  async ngOnInit(): Promise<void> {

    this.cookieService.set("cardNewotp", "",true);

    let BN = await this.cookieService.get("cardNewotp", false);
    if (BN) {
      this.otp1 = BN;
      console.log(this.otp1,"otp1");
      

    }

// 
this.CommonService.presentLoading();
this.auth.accessToken = await this.CommonService.Get("token");
this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
  if (data?.response?.code == 1) {
   this.CommonService.hideLoading();



  }
  else {
    await this.CommonService.hideLoading();
    this.CommonService.ParseErrorAlert("", "", this.router, data);
  }

});
// 

    
  }


  onnewKeyDown(event: KeyboardEvent): void {

    if (event.key === 'Enter') {
      // this.LoginRegisterEmailOTP();

    }
  }

  onnewOtpChange(e) {
    this.newOtp=""
    if (e.length == 4) {
      this.newOtp = e.toString();
    } else {
  
    }
  }


  // isValid() {
  //   if (!this.otp) {
  //     return true
  //   } else {
  //     return false

  //   }
  // }

  // isValid(): boolean {
  //   // Disable the button if `otp` is undefined, empty, or does not match `otp1`
  //   if (!this.newOtp || this.newOtp !== this.otp1) {
  //     return true; // Button remains disabled
  //   }
  //   return false; // Button is enabled
  // }

  isnewValid() {
    if (!this.newOtp) {
      return true
    } else {
      return false

    }
  }

  back() {
    this.location.back()
  }
  
  next(){
    console.log("pin",this.newOtp);
    
  
    this.cookieService.set("cardNewotp", this.newOtp,true);
    this.router.navigateByUrl("/ChangeCardPinConfirm"); 
  }


  getMessage(key, control) {

    let error = "";
    this.translate.get([key]).subscribe((data) => {
      if (control == "officeno") {
        if (key == "MobileMin") {
          error = data[key];
          // error = error.replace("{minLength}", this.mobileminlength.toString());
        } else if (key == "MobileMax") {
          error = data[key];
          // error = error.replace("{maxLength}", this.mobilemaxlength.toString());
        } else {
          error = data[key];
        }
      } else {
        error = data[key];
      }
    });
    return error;
  }


  back2sinnad(){
    this.router.navigateByUrl("/DashboardCreditCards"); 
  }

}

